module.exports = __webpack_public_path__ + "static/billboard-5e37a9a9defa563798caeeaa635d6afe.png";